// Copyright (c) 2019 Fall Guy LLC All Rights Reserved.

import React                    from 'react';

//----------------------------------------------------------------//
async function clearBrowserCacheAsync ( version ) {

    const keys = await caches.keys ();
    for ( let name in keys ) {
        await caches.delete ( name );
    }
    window.location.reload ( true );
}

//----------------------------------------------------------------//
export function useVersionedBrowserCache ( endpoint ) {

    React.useEffect (() => {
        ( async function () {

            const meta = await ( await fetch ( endpoint || '/', { cache: 'no-cache' })).json ();
            const localBuildID = localStorage.getItem ( 'build' );

            if ( !( meta && meta.buildID )) return;
            
            if ( localBuildID !== meta.buildID ) {
                await clearBrowserCacheAsync ();
                localStorage.setItem ( 'build', meta.buildID );
            }
        })();
    });
}
